export const RESERVED_HOT_PINK = 'hotpink'

